const ClientSegment = {
  CORPORATE: 'Corporate',
  K12: 'K12',
  ONLINE: 'Online',
}

export default ClientSegment
